import { render, staticRenderFns } from "./FaqModalAnswer.vue?vue&type=template&id=5ac6141b&"
import script from "./FaqModalAnswer.vue?vue&type=script&lang=js&"
export * from "./FaqModalAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports